export default __webpack_public_path__ + "static/media/LogoKahshNewColor.c7331bf7.svg";